import React, { useEffect, useState } from "react";
import ItemsCategoryTable from "./Components/ItemsCategoryTable";
import { useNavigate } from "react-router-dom";
import { hasAddAccess, hasViewAccess } from "../../../../../Common/CheckAccess";
import { Button } from "react-bootstrap";
import InventoryModal from "./Components/ViewStockModal";
import { toast } from "react-toastify";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";

const Procurements = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  useEffect(() => {
    async function fetchStockData() {
      try {
        let baseUrl = getBaseUrl();
        const token = localStorage.getItem("token");
        const hotel_id = localStorage.getItem("hotel_id");

        const response = await fetch(`${baseUrl}/report/stock-level?hotel_id=${hotel_id}`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          let result = await response.json();
          setInventoryData(result?.data||[]);
        } else {
          setInventoryData([]);
        }
      } catch (error) {
        toast.error("Failed to fetch offers.");
      }
    }
    fetchStockData();
  }, []);

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Requests List</h3>
              <div className="col-auto d-flex gap-3 w-sm-100">
                {hasAddAccess(permissions, "inventory") && (
                  <button
                    type="button"
                    className="btn btn-dark"
                    onClick={() => navigate("/procurements/create-procurement")}
                  >
                    Add Request
                  </button>
                )}
                {hasViewAccess(permissions, "inventory") && (
                    <Button
                      variant="primary"
                      // size="lg"
                      onClick={() => setShowModal(true)}
                      className="d-flex align-items-center mx-auto"
                    >
                      <i className="bi bi-box-seam me-2"></i>
                      View Inventory
                    </Button>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body" style={{ overflowX: "auto" }}>
                <ItemsCategoryTable />
              </div>
            </div>
          </div>
        </div>
      </div>
      <InventoryModal
        show={showModal}
        onHide={() => setShowModal(false)}
        data={inventoryData}
      />
    </>
  );
};

export default Procurements;
